<div class="meo-history-page">
  <!-- Header -->
  <div class="history-top-bar">
    <h2 class="history-page-title">{{ ss.t('meo_title') + ' ' + ss.t('common_chat') }}</h2>
    <div class="top-bar-actions">
      <button class="icon-btn" (click)="onOpenAiMemory()"
        [attr.aria-label]="ss.t('meo_ai_preferences_title')">
        <app-svg name="setting" height="18" width="18" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
      </button>
      <button class="icon-btn" (click)="onClose()"
        [attr.aria-label]="ss.t('common_close')">
        <app-svg name="topBarClose" height="16" width="16" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
      </button>
    </div>
  </div>

  <!-- Session list -->
  <div class="session-list hide-scrollbar">
    @for (session of meoStore.displayedSessions(); track session.id) {
      <button class="session-item" (click)="onSelectSession(session.id)">
        <div class="session-content">
          <span class="session-title">{{ session.title || ss.t('meo_untitled') }}</span>
          @if (getSuggestionCount(session) || getConfirmedCount(session)) {
            <div class="session-stats">
              @if (getSuggestionCount(session); as suggestionCount) {
                <span class="stat-item">
                  <app-svg name="roundedSquare" [color]="ss.theme().color7"
                      style="height: 16px; width: 16px;"></app-svg>
                  <span class="stat-count">{{ suggestionCount }}</span>
                </span>
              }
              @if (getConfirmedCount(session); as confirmedCount) {
                <span class="stat-item">
                  <app-svg name="checklist" [color]="ss.theme().color7"
                      style="height: 16px; width: 16px;"></app-svg>
                  <span class="stat-count">{{ confirmedCount }}</span>
                </span>
              }
            </div>
          }
        </div>
        <span class="session-time">{{ getRelativeTime(session.lastActivityAt) }}</span>
      </button>
    } @empty {
      <div class="empty-state">
        <app-svg [name]="brandLogo" height="48" [color]="ss.theme().color35"></app-svg>
        <p class="empty-text">{{ ss.t('meo_no_history') }}</p>
      </div>
    }
    @if (meoStore.displayedSessions().length > 0 && (meoStore.hasMoreLocalSessions() || meoStore.hasMoreCloudSessions())) {
      <button class="load-more-btn" (click)="onLoadMore()">
        {{ ss.t('common_loadMore') }}
      </button>
    }
  </div>

  <!-- New chat FAB -->
  <button class="new-chat-fab" (click)="onNewChat()"
    appLongPress (appLongPress)="onNewChatLongPress()"
    [attr.aria-label]="ss.t('meo_new_session')">
    <app-svg name="meoSparkle" height="24" width="24" [color]="'#FFFFFF'"></app-svg>
  </button>
</div>
